export const isBusinessWithIbn = (isBusinessCustomer?: boolean, familyNumber?: string): boolean =>
    Boolean(isBusinessCustomer) && Boolean(familyNumber) && familyNumber?.[6] === '6';

export const isFamilyMember = (familyNumber?: string, isBusinessCustomer?: boolean): boolean =>
    Boolean(familyNumber) && !isBusinessCustomer;
